import { EVENT_MODALS_KEY } from 'src/config/event/eventConfig';

export const getEventModalShownDatesFromLS = (): string[] => {
  return JSON.parse(localStorage.getItem(EVENT_MODALS_KEY) || '[]');
};

export const addNewDateToShownDatesLS = (date: string) => {
  const datesFromLs = getEventModalShownDatesFromLS();

  datesFromLs.push(date);
  localStorage.setItem(EVENT_MODALS_KEY, JSON.stringify(datesFromLs));
};

export const removeEventModalShownDatesFromLS = () => {
  localStorage.removeItem(EVENT_MODALS_KEY);
};
